(function() {
    angular.module('emarket.main.post').controller('ReportPostController', ['$rootScope', '$scope', '$timeout', '$mdPanel', '$q', 'mdPanelRef', '$log', 'post', function($rootScope, $scope, $timeout, $mdPanel, $q, mdPanelRef, $log, post) {
        var vm = this;
        vm.isLoading = false;
        vm.close = function() {
            mdPanelRef.close($mdPanel.closeReasons.ESCAPE);
        };
        vm.sendReport = function() {            
            var promise = $q(function(resolve) {
                $timeout(function() {
                    resolve();
                }, 4000);
            });
            vm.isLoading = true;
            //TODO send http post request
            promise.then(function() {
                vm.isLoading = false;
                mdPanelRef.close();
            }).catch(function() {
                vm.isLoading =false;
            });
        };
        var onLocationChange = $rootScope.$on('$locationChangeSuccess', function() {
            vm.close();
        });
        var onStateChangeStart = $rootScope.$on('$stateChangeStart', function() {
            vm.close();
        });
        $scope.$on('$destroy', function() {
            onLocationChange();
            onStateChangeStart();
        });
    }]);
}());
